/*
  Nordic Aim: gör tabeller i blogginlägg läsbara på mobil.

  På 390 px får en sexkolumnstabell bara cirka 60 px per kolumn, vilket bryter värden
  som "17 890 kr" över tre rader och får långa ord att svämma över i grannkolumnen.
  CSS:en i na-chrome.css staplar därför varje rad till ett kort på mobil, och behöver
  då kolumnnamnet bredvid varje värde. Ett pseudoelement kan inte läsa tabellhuvudet,
  så vi kopierar hit rubrikerna till data-label på varje cell.

  Körs en gång, ändrar ingenting på desktop. JOGR.
*/
(function () {
  var tables = document.querySelectorAll('.article-template__content table');
  if (!tables.length) return;

  Array.prototype.forEach.call(tables, function (table) {
    var heads = table.querySelectorAll('thead th');
    if (!heads.length) return;

    var labels = Array.prototype.map.call(heads, function (th) {
      return th.textContent.replace(/\s+/g, ' ').trim();
    });

    Array.prototype.forEach.call(table.querySelectorAll('tbody tr'), function (tr) {
      Array.prototype.forEach.call(tr.children, function (cell, i) {
        if (labels[i]) cell.setAttribute('data-label', labels[i]);
      });
    });

    table.classList.add('na-rte-table');
  });
})();
